var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddmoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525",
    transform: "translate(606.596 -149.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M-606.6,164.524a15.005,15.005,0,0,1,15.01-15.005,15,15,0,0,1,14.99,15.056,15.006,15.006,0,0,1-15.041,14.944A15.01,15.01,0,0,1-606.6,164.524Zm17-2.007c0-1.671,0-3.3,0-4.92a2,2,0,0,0-1.992-2.081,2,2,0,0,0-2.009,2.1q0,2.281,0,4.562v.343c-1.67,0-3.294,0-4.919,0a2,2,0,0,0-2.081,1.991,2,2,0,0,0,2.095,2.01q2.281,0,4.562,0h.343v.387q0,2.3,0,4.594a1.911,1.911,0,0,0,.729,1.556,1.9,1.9,0,0,0,2.135.26,1.915,1.915,0,0,0,1.135-1.829c.01-1.542,0-3.083,0-4.625v-.343h4.826a2.011,2.011,0,0,0,2.175-1.993,2.044,2.044,0,0,0-2.189-2.018c-1.478.036-2.958.008-4.437.008Z",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    d: "M-499.626,252.486h.373c1.479,0,2.959.028,4.437-.008a2.044,2.044,0,0,1,2.189,2.018,2.011,2.011,0,0,1-2.175,1.993h-4.826v.343c0,1.542.008,3.083,0,4.625a1.915,1.915,0,0,1-1.135,1.829,1.9,1.9,0,0,1-2.135-.26,1.911,1.911,0,0,1-.729-1.556q0-2.3,0-4.594v-.387h-.343q-2.281,0-4.562,0a2,2,0,0,1-2.095-2.01,2,2,0,0,1,2.081-1.991c1.624,0,3.248,0,4.919,0v-.343q0-2.281,0-4.562a2,2,0,0,1,2.009-2.1,2,2,0,0,1,1.992,2.081C-499.624,249.191-499.626,250.815-499.626,252.486Z",
    transform: "translate(-89.969 -89.968)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmoreicon);
export default __webpack_public_path__ + "static/media/addmoreicon.e349d0a9b8a20da29ec27e769b0808ad.svg";
export { ForwardRef as ReactComponent };